export default "__VITE_ASSET__CPGMDDVS__"